import React, { useState, useEffect } from "react";
import { Button } from "antd";
import styled from "styled-components";
import i18n from "i18next";

import { PRIMARY_600, PRIMARY_800 } from "../../constant/colors";

// Timelapse-loader Refresh button: a progress bar fills the button over COUNTDOWN_DURATION seconds
// and auto-dismisses the prompt when it completes (mirrors the Redi "Okay, got it" countdown button).
// Clicking Refresh reloads the page; hovering pauses the countdown.
const COUNTDOWN_DURATION = 10; // seconds before the prompt auto-dismisses

const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 8px;
  overflow: hidden;
`;

const ProgressBarOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${(props) => props.$progress || 0}%;
  background: ${PRIMARY_800};
  transition: width 1s linear;
  pointer-events: none;
  z-index: 1;
  border-radius: 8px 0 0 8px;
`;

const RefreshButton = styled(Button)`
  position: relative;
  background-color: ${PRIMARY_600};
  border-color: ${PRIMARY_600};
  border-radius: 8px;

  /* Keep the label above the progress overlay */
  & > span {
    position: relative;
    z-index: 2;
  }
`;

function PatientUpdatedRefreshButton({ onRefresh, onTimeout }) {
  const [countdown, setCountdown] = useState(COUNTDOWN_DURATION);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused || countdown <= 0) return undefined;

    const timer = setInterval(() => setCountdown((prev) => Math.max(prev - 1, 0)), 1000);

    return () => clearInterval(timer);
  }, [countdown, isPaused]);

  // Auto-dismiss the prompt when the timelapse completes (does not refresh).
  useEffect(() => {
    if (countdown === 0) onTimeout();
  }, [countdown, onTimeout]);

  const progress = ((COUNTDOWN_DURATION - countdown) / COUNTDOWN_DURATION) * 100;

  return (
    <ButtonWrapper onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
      <ProgressBarOverlay $progress={progress} />
      <RefreshButton type="primary" size="small" data-testid="patient-updated-refresh-btn" onClick={onRefresh}>
        {i18n.t("patient_updated.refresh")}
      </RefreshButton>
    </ButtonWrapper>
  );
}

export default PatientUpdatedRefreshButton;
